import React from "react";
import {
  Card,
  CardContent,
  Typography,
  Box,
  useTheme,
  Button,
  Divider,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { faNoteSticky } from "@fortawesome/free-solid-svg-icons";
import CardHeader from "./CardHeader";
import * as f from "../../../utils/formatter";
import { parseUtcDateTime } from "shared/src/date.mjs";

function formatTimestamp(ts) {
  if (!ts) return "";
  const d = ts instanceof Date ? ts : parseUtcDateTime(ts);
  if (!(d instanceof Date) || Number.isNaN(d.getTime())) return "";
  const pad = (n) => String(n).padStart(2, "0");
  return `${pad(d.getDate())}.${pad(d.getMonth() + 1)}.${d.getFullYear()} ${pad(
    d.getHours(),
  )}:${pad(d.getMinutes())}`;
}

const MAX_COLLAPSED = 3;

export default function NextAppointmentNoteCard({ notes = [] }) {
  const { t } = useTranslation();
  const theme = useTheme();
  const [expanded, setExpanded] = React.useState(false);

  const visible = expanded ? notes : notes.slice(0, MAX_COLLAPSED);
  const hasMore = notes.length > MAX_COLLAPSED;

  return (
    <Card sx={{ height: "100%" }}>
      <CardContent>
        <CardHeader
          title={t("client.nextAppointmentNote")}
          color={theme.palette.warning.main}
          faIcon={faNoteSticky}
        />

        <Box sx={{ mt: 2, display: "flex", flexDirection: "column", gap: 2 }}>
          {notes.length > 0 ? (
            <>
              {visible.map((n, idx) => {
                const key = n.id ?? `next-note-${idx}`;
                const author =
                  f.fullName(n.employee) ||
                  n.employee?.username ||
                  n.username ||
                  "";
                const role = n.role || "";

                return (
                  <Box key={key}>
                    <Typography variant="body2" sx={{ whiteSpace: "pre-wrap" }}>
                      {n.note || ""}
                    </Typography>
                    <Typography
                      variant="caption"
                      color="text.secondary"
                      fontSize={9}
                      sx={{ display: "block", mt: 0.5 }}
                    >
                      {formatTimestamp(n.created_at)} • {author}
                      {role ? ` (${role})` : ""}
                    </Typography>
                    {idx < visible.length - 1 && <Divider sx={{ mt: 1.5 }} />}
                  </Box>
                );
              })}

              {hasMore && (
                <Button
                  size="small"
                  onClick={() => setExpanded((v) => !v)}
                  sx={{ mt: 1 }}
                >
                  {expanded ? t("Méně") : t("Zobrazit více")}
                </Button>
              )}
            </>
          ) : (
            <Typography variant="body1">Žádné poznámky</Typography>
          )}
        </Box>
      </CardContent>
    </Card>
  );
}
